import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

// UI/menu visibility preferences, persisted per browser. Lets an operator hide
// menus that aren't ready for end users (e.g. QNA AI) without touching code.
interface UIPrefsState {
  qnaMenuEnabled: boolean;
  setQnaMenuEnabled: (v: boolean) => void;
}

export const useUIPrefsStore = create<UIPrefsState>()(
  persist(
    (set) => ({
      // QNA menu is hidden by default; enable it from Pengaturan when ready.
      qnaMenuEnabled: false,
      setQnaMenuEnabled: (v: boolean) => set({ qnaMenuEnabled: v }),
    }),
    {
      name: "pnbp-ui-prefs",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
